import React from 'react'
import {Row, Col, InlineLoader} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'

import DynamicEntriesTable, {DynamicEntry} from '../../../../component/dynamic-entries-table'
import SummaryPageFooter from '../../components/summary-page-footer'
import {SECTION_BANK_DETAILS} from '../../../../constants/sections'
import {FormContentWrapper} from '../../../../ui/form'
import {StyledImg, ImageContainer} from '../../../summary-page-image/styles'
import {StyledParagraph} from '../../../../ui/styles'
import SummaryPageHeader from '../../components/summary-page-header'

const tableHeadlines = ['accountHolder', 'accountNumber']

/** One row of the BankAccountSummaryPage table. */
type BankAccountSummaryEntry = DynamicEntry & {
  route: string
  accountHolder: string
  accountNumber: string
}

export type BankAccountSummaryPageProps = {
  isLoading: boolean
  bankAccountSummary: BankAccountSummaryEntry[]
  isReadonly: boolean
  createBankAccount: () => void
}

const BankAccountSummaryPage: React.FC<BankAccountSummaryPageProps> = ({
  isLoading,
  bankAccountSummary,
  isReadonly,
  createBankAccount,
}) => {
  const {t} = useTranslation('charon')

  return (
    <>
      <FormContentWrapper>
        <SummaryPageHeader
          ctaText={t(`sub-section-menu.${SECTION_BANK_DETAILS}.create`)}
          onCreate={createBankAccount}
          isDisabled={isReadonly}
        />
        {isLoading && (
          <Row>
            <Col>
              <InlineLoader />
            </Col>
          </Row>
        )}
        {!isLoading && bankAccountSummary.length < 1 && (
          <>
            <Row justifyContent="center" data-ident="seller-bank-account-page.no-accounts.image">
              <Col auto>
                <ImageContainer>
                  <StyledImg src="/assets/images/no-results-dynamic-entries.png" alt="no-results" />
                </ImageContainer>
              </Col>
            </Row>
            <Row justifyContent="center">
              <Col auto>
                <StyledParagraph textAlign="center">
                  {t('seller-bank-account-summary-page.no-results.message')}
                </StyledParagraph>
              </Col>
            </Row>
          </>
        )}
        {!isLoading && bankAccountSummary.length > 0 && (
          <Row mb={40} data-ident="seller-bank-account.summary-table">
            <Col>
              <DynamicEntriesTable
                dataList={bankAccountSummary || []}
                headlines={tableHeadlines}
                transPrefix="seller-bank-account-summary-page"
              />
            </Col>
          </Row>
        )}
      </FormContentWrapper>

      <SummaryPageFooter sectionName={SECTION_BANK_DETAILS} />
    </>
  )
}

export default BankAccountSummaryPage
